"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChildRow = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../../atoms");

var _Table = require("../Table.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ChildRow = ({
  columns,
  data,
  isCollapse,
  showIndex,
  isSelectable,
  isParentSelected,
  parentIndex,
  handleChildRowSelection,
  rowClassName,
  cellClassName,
  handleRowClick,
  onRowMouseEnter,
  onRowMouseLeave
}) => {
  const isChild = true;

  const handleRowMouseEnter = (e, obj) => {
    typeof onRowMouseEnter === 'function' && onRowMouseEnter(e, obj, isChild);
  };

  const handleRowMouseLeave = (e, obj) => {
    typeof onRowMouseLeave === 'function' && onRowMouseLeave(e, obj, isChild);
  };

  return data.children.map((obj1, childIndex) => /*#__PURE__*/_react.default.createElement(_Table.StyledRow, {
    key: childIndex,
    className: `child-row ${rowClassName}`,
    isLastChild: childIndex === data.children.length - 1,
    onClick: e => handleRowClick(e, obj1),
    onMouseEnter: e => handleRowMouseEnter(e, obj1),
    onMouseLeave: e => handleRowMouseLeave(e, obj1)
  }, showIndex && !isSelectable && /*#__PURE__*/_react.default.createElement(_Table.StyledCell, null), isSelectable ? /*#__PURE__*/_react.default.createElement(_Table.StyledCell, {
    className: cellClassName
  }, /*#__PURE__*/_react.default.createElement(_Table.CheckboxWrapper, {
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/_react.default.createElement(_atoms.Checkbox, {
    value: '' + childIndex,
    checked: !obj1._isDisable && (obj1._isCheck || isParentSelected),
    onChange: e => {
      handleChildRowSelection(e, { ...obj1,
        _isCheck: e.target.checked
      }, parentIndex, childIndex);
    },
    disabled: obj1._isDisable
  }))) : '', isCollapse && /*#__PURE__*/_react.default.createElement(_Table.StyledCell, {
    className: `expansion-cell ${cellClassName}`
  }), columns.map(obj2 => {
    return obj2.children && obj2.children.map(({
      accessor,
      render
    }, m) => {
      return render !== undefined ? /*#__PURE__*/_react.default.createElement(_Table.StyledCell, {
        key: m,
        className: cellClassName
      }, render(obj1)) : /*#__PURE__*/_react.default.createElement(_Table.StyledCell, {
        key: m,
        className: cellClassName
      }, obj1[accessor]);
    });
  })));
};

exports.ChildRow = ChildRow;